import $ from 'jquery';
import galleria from '../libs/galleria';

export default
    {
        init() {
        },

        finalize() {
            galleria();
        },
    }



// WEBPACK FOOTER //
// ./scripts/routes/templateGalleria.js